// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"dc2b29fd","907":"22f3d59a"}[chunkId] + ".chunk.js";
};